import { createSlice, isAction } from "@reduxjs/toolkit";
import { fetchTransferHistorys } from "./thunk";

interface TransferHistoryState {
  TransferHistoryList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedTransferHistoryTask: any;
}

const initialState: TransferHistoryState = {
  TransferHistoryList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedTransferHistoryTask: null,
};

const TransferHistorySlice = createSlice({
  name: "TransferHistoryTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferHistorys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransferHistorys.fulfilled, (state, action) => {
        state.loading = false;
        state.TransferHistoryList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchTransferHistorys.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch TransferHistoryTasks";
      });
  },
});

export default TransferHistorySlice.reducer;
